/**
 * Created by chenqifeng on 2016/9/1.
 */
import {
	request
}             from '../http';
import domain from '../domain';
import {maple} from "tgPage";

let MemberService = function(){
		if( domain.env === 'online' ){
			this.domain = '//mserv.51tiangou.com';
		}
		else{
			this.domain = '//mserv.' + domain.env + '.66buy.com.cn';
		}
	}
	;

MemberService.prototype.memberInfo = function(params={}){
	var that = this;
	params.type = 'GET';
	return that._serviceAjaxCom('/publics/member/info', params);
};

MemberService.prototype.cardCreateAble = function(params={}){
	var that = this;
	params.type = 'GET';
	return that._serviceAjaxCom('/publics/memberCard/store/cardCreateAble', params);
};

MemberService.prototype.createCard = function(params={}){
	var that = this;
	params.type = 'GET';
	that._serviceAjaxCom('/publics/memberCard/createCard', params);
};
/**
 * 更新头像
 * @param params
 */
MemberService.prototype.updatePhone = function(params){
	params.type = 'POST';
	this._serviceAjaxCom('/publics/member/update/photo', params);
};

/**
 * 更新昵称
 * @param params
 */
MemberService.prototype.memberNickname = function(params){
	params.type = 'POST';
	this._serviceAjaxCom('/publics/member/update/nickname', params);
};

/**
 * 更新个性签名
 * @param params
 */
MemberService.prototype.memberSignature = function(params){
	params.type = 'POST';
	this._serviceAjaxCom('/publics/member/update/signature', params);
};

/**
 * 查询个人资料
 * @param params
 */
MemberService.prototype.socialProfile = function(params){
	params.type = 'GET';
	this._serviceAjaxCom('/publics/member/socialProfile', params);
};

/**
 * 获取我的信息
 * @param params
 */
MemberService.prototype.mineInfo = function(params = {}){
	var that = this;
	params.type = 'GET';
	return that._serviceAjaxCom('/publics/mine/info', params);
};

/**
 * 我的信息简洁版
 * 2018-07-10 用于部分场景替换 mineInfo 接口
 * */
MemberService.prototype.baseInfo = function(params = {}){
	params.type = 'GET';
	return this._serviceAjaxCom('/publics/mine/baseInfo', params);
};

/**
 * 关注和取消关注(专柜)
 * @param params
 */
MemberService.prototype.attention = function(params = {}){
	var that = this;
	params.type = 'GET';
	return that._serviceAjaxCom('/publics/member/counter/attention', params);
};

/**
 * 关注和取消关注(门店)
 * @param params
 */
MemberService.prototype.storeAttention = function(params = {}){
	var that = this;
	params.type = 'GET';
	return that._serviceAjaxCom('/publics/member/store/subscribed', params);
};

/**
 * 获取结算码弹窗情况
 */
MemberService.prototype.openState = function(params = {}){
	var that = this;
	params.type = 'GET';
	that._serviceAjaxCom('/publics/member/openState', params);
};

/**
 * @summary 关闭扫码页
 * @parma   {Object}    [params={}]
 * */
MemberService.prototype.close = function(params = {}){
	params.type = 'POST';
	this._serviceAjaxCom('/publics/member/close', params);
};

/**
 * 店铺所有会员卡
 * @param params storeIds
 */
MemberService.prototype.storeToCard = function(params){
	params.type = 'POST';
	this._serviceAjaxCom('/publics/memberCard/storeToCard', params);
};

MemberService.prototype.validateMemberCard = function(params){
	params.type = 'POST';
	this._serviceAjaxCom('/publics/memberIdentity/validate', params);
};

MemberService.prototype.specialAddOrUpdate = function(params){
	params.type = 'POST';
	this._serviceAjaxCom('/publics/memberIdentity/special/addOrUpdate', params);
};

MemberService.prototype.specialQueryByMemberId = function(params){
	params.type = 'POST';
	this._serviceAjaxCom('/publics/memberIdentity/special/queryByMemberId', params);
};

/**
 * 防黄牛
 *
 */
MemberService.prototype.secKey = function(params){
	var that = this;
	params.type = 'POST';
	that._serviceAjaxCom('/publics/app/secKey', params);
};

MemberService.prototype.scoreLimit = function(params){
	this._serviceAjaxCom('/publics/store/conf/score/limit', params);
};

MemberService.prototype.memberAddressList = function(params){
	this._serviceAjaxCom('/publics/memberAddress/list', params);
};

MemberService.prototype.getAddressById = function(params){
	this._serviceAjaxCom('/publics/memberAddress/getById', params);
};

MemberService.prototype.getDefaultAddress = function(params){
	this._serviceAjaxCom('/publics/memberAddress/queryDefault', params);
};

MemberService.prototype._serviceAjaxCom = function(url, params){
	params.url = this.domain + url;
	return request(params);
};

/**
 * 会员解除绑定会员卡
 * 以下参数为必填参数
 * @param   {Object}    params
 * @param   {Object}    params.data
 * @param   {Number}    params.data.cid
 * @param   {Number}    params.data.groupId
 * @param   {Function}  params.success
 * */
MemberService.prototype.unbind = function(params){
	if( params.data.cid ){
		this._serviceAjaxCom('/publics/memberCard/unbind', params);
	}
	else{
		params.success([]);
		return false;
	}
};

/**
 * 二次绑定接口
 * @param   {Object}    params
 * @param   {Object}    params.data
 * @param   {Number}    params.data.cid
 * @param   {Number}    params.data.groupId
 * @param   {Function}  params.success
 * */
MemberService.prototype.noValidate = function(params){
	params.type = 'POST';
	return this._serviceAjaxCom('/publics/memberCard/bind/noValidate', params);
};

/**
 * 查询当前会员卡
 * @param   {Object}    params
 * @param   {Object}    params.data
 * @param   {Number}    params.data.storeId
 * @param   {Function}  params.success
 */
MemberService.prototype.cidBind = function(params){
	params.type = 'POST';
	this._serviceAjaxCom('/publics/memberCard/cidBind', params);
};

/**
 * 实名认证相关 - 获取实名认证列表
 * @param   {Object}    params
 * @param   {Function}  params.success
 * */
MemberService.prototype.identityList = function(params){
	this._serviceAjaxCom('/publics/memberIdentity/getMemberIdentityList', params);
};

/**
 * 实名认证相关 - 查询我的实名认证
 * @param   {Object}        params
 * @param   {Object}        params.data
 * @param   {String|Number} params.data.id
 * @param   {Function}      params.success
 * */
MemberService.prototype.identityGetById = function(params){
	this._serviceAjaxCom('/publics/memberIdentity/getById', params);
};

/**
 * 实名认证相关 - 根据用户姓名查询实名认证
 * @param   {Object}    params
 * @param   {Object}    params.data
 * @param   {String}    params.data.name
 * @param   {Function}  params.success
 * */
MemberService.prototype.identityGetByName = function(params){
	this._serviceAjaxCom('/publics/memberIdentity/getByName', params);
};

/**
 * 实名认证 - 新增实名认证
 * @param   {Object}    params
 * @param   {Object}    params.data
 * @param   {String}    params.data.name
 * @param   {String}    params.data.idCardNumber
 * @param   {String}    params.data.idCardFront
 * @param   {String}    params.data.idCardBack
 * @param   {Function}  params.success
 * */
MemberService.prototype.identityAdd = function(params){
	params.type = 'POST';
	this._serviceAjaxCom('/publics/memberIdentity/add', params);
};

/**
 * 实名认证 - 更新实名认证
 * @param   {Object}        params
 * @param   {Object}        params.data
 * @param   {String|Number} params.data.id
 * @param   {String}        params.data.name
 * @param   {String}        params.data.idCardNumber
 * @param   {String}        params.data.idCardFront
 * @param   {String}        params.data.idCardBack
 * @param   {Function}      params.success
 * */
MemberService.prototype.identityUpdate = function(params){
	params.type = 'POST';
	this._serviceAjaxCom('/publics/memberIdentity/update', params);
};

/**
 * 实名认证相关 - 删除我的实名认证
 * @param   {Object}        params
 * @param   {Object}        params.data
 * @param   {String|Number} params.data.id
 * @param   {Function}      params.success
 * */
MemberService.prototype.identityDelete = function(params){
	this._serviceAjaxCom('/publics/memberIdentity/delete', params);
};

/**
 * @deprecated
 * */
// MemberService.prototype.identityUpload = function(params){
// 	this._serviceAjaxCom('/publics/memberIdentity/upload', params);
// };

/**
 * 基于优惠券推送注册
 * @param   {Object}    params
 * @param   {Object}    params.data
 * @param   {String}    params.data.phone
 * @param   {String}    params.data.couponId
 * @param   {String}    params.data.sign
 * @param   {Function}  params.success
 * */
MemberService.prototype.fastRegister = function(params){
	params.type = 'POST';
	this._serviceAjaxCom('/publics/register/fastRegister', params);
};

/**
 * 获取手机验证码
 * @param params
 *
 */
MemberService.prototype.authCode = function(params){
	params.type = 'POST';
	this._serviceAjaxCom('/publics/authCode/send', params);
};

/**
 * 微信下联合登录
 * @param   params
 * 2021-06-28
 * #50115   付费会员——涉及到登录接口全部替换成新接口
 * /publics/login/wechatLogin => /web/member/wechat-login
 * 统一使用 login 接口
 */
MemberService.prototype.weChatLogin = function(params){
	params.type = 'POST';
	params.contentType = params.contentType || 'application/json';
	
	this._serviceAjaxCom('/web/member/wechat-login', params);
};

/**
 * 订阅和取消门店
 * @param params
 */
MemberService.prototype.subscribed = function(params={}){
	var that = this;
	params.type = 'GET';
	return that._serviceAjaxCom('/publics/member/store/subscribed', params);
};

/**
 * 结算码界面查询
 * @param   params
 * */
MemberService.prototype.memberCodePage = function(params={}){
	this._serviceAjaxCom('/publics/member/memberCode/page/get', params);
};

/**
 * @description 用戶管理  修改手机号码  旧手机号获取短信验证码
 * @date 不详
 * @author Ysy #52016
 * @date 2022/4/24
 *
 * @deprecated  2022-07-07 #52352
 *  废弃接口 publics/sms/sendMemberVerificationCode
 *  替换为 publics/web/sms/sendSms
 */
MemberService.prototype.sendMemberVerificationCodeOld = function(params){
	var that = this;
	params.type = 'POST';

	that._serviceAjaxCom('/publics/sms/sendMemberVerificationCode', params);
};

/**
 * @description 用戶管理  修改手机号码  旧手机号获取短信验证码
 * @date 不详
 * @author Ysy #52016
 * @date 2022/4/24
 *
 * sence:   22 短信快捷登录
 *          11 密码修改
 *          12 修改手机号
 *          24 会员注销
 */
MemberService.prototype.sendMemberVerificationCode = function(params){
	let that = this
		;

	params.type = 'POST';
	params.contentType = params.contentType || 'application/json';

	that._serviceAjaxCom('/publics/web/sms/sendSms', params);
};

//旧手机号修改 下一步
MemberService.prototype.validateOldCellphone = function(params){
	var that = this;
	params.type = 'POST';
	that._serviceAjaxCom('/publics/member/validateOldCellphone', params);
};

/**
 * 新手机号 获取短信验证码
 * 2021-08-05 回退旧接口
 * */
MemberService.prototype.sendVerificationCodeForWeb = function (params) {
	var that = this;
	params.type = 'POST';
	that._serviceAjaxCom("/publics/sms/sendVerificationCodeForWeb", params);
};

/**
 * @description 新手机号 更新手机号码
 * @author Ysy
 * @description 接口替换  /publics/member/update/cellphone  =>  publics/member/web/update/cellphone
 * @date 2022/4/24
 */
MemberService.prototype.updateCellphone = function(params){
	var that = this;
	params.type = 'POST';
	that._serviceAjaxCom('/publics/member/web/update/cellphone', params);
};

/*
    人脸识别
 */
//人脸识别状态查询
MemberService.prototype.getRecognitionState = function(params){
	var that = this;
	params.type = 'POST';
	that._serviceAjaxCom('/publics/member/facial/getState', params);
};

//关闭人脸识别
MemberService.prototype.recognitionClose = function(params){
	var that = this;
	params.type = 'POST';
	that._serviceAjaxCom('/publics/member/facial/off', params);
};

//打开人脸识别并上传图片
MemberService.prototype.recognitionOpen = function(params){
	var that = this;
	params.type = 'POST';
	that._serviceAjaxCom('/publics/member/facial/on', params);
};

/**
 * 旗舰店订阅
 * @param   {Object}    params
 * @param   {Object}    params.data
 * @param   {Number|String} params.data.brandId
 * @param   {Number}        params.data.state   订阅状态，0 取消，1 订阅
 * @param   {Function}      params.success
 * */
MemberService.prototype.flagStoreSubscribed = function(params){

	params.type = 'POST';

	this._serviceAjaxCom('/publics/member/brand/subscribed', params);
};

/**
 * 查询用户是否有已订阅品牌
 * */
MemberService.prototype.memberSubscribed = function(params){
	params.type = 'POST';

	return this._serviceAjaxCom('/publics/member/brand/queryMemberSubscribed', params);
};

/**
 * 微信续登录统计用
 * */
MemberService.prototype.memberCollect = function(params){
	params.type = 'POST';

	return this._serviceAjaxCom('/publics/collect', params);
};

/**
 * 验证短信验证码正确性
 * */
MemberService.prototype.validate = function(params){
	params.type = 'POST';

	return this._serviceAjaxCom('/publics/code/validate', params);
};

/**
 * 设置地址为默认地址
 * */
MemberService.prototype.setDefaultAddress = function(params){
	params.type = 'POST';

	return this._serviceAjaxCom('/publics/memberAddress/new/default', params);
};

/**
 * 解绑微信绑定关系
 * @param params
 */
MemberService.prototype.unbindWechat = function(params){
	return this._serviceAjaxCom('/publics/member/unbindWechat', params);
};

/**
 * 【会员注销】查需要手动处理的信息才可进行注销
 * @param params
 */
MemberService.prototype.manualProcessing = function(params){
	params.type = 'POST';
	return this._serviceAjaxCom('/publics/member/cancel/cancelProcessing', params);
};

/**
 * 【会员注销】记录注销原因
 * @param params
 */
MemberService.prototype.recordReason = function(params){
	params.type = 'POST';
	return this._serviceAjaxCom('/publics/member/cancel/recordReason', params);
};

/**
 * 【会员注销】记录用户点击开始注销的操作
 * @param params
 */
MemberService.prototype.agree = function(params){
	params.type = 'POST';
	return this._serviceAjaxCom('/publics/member/cancel/agree', params);
};

/**
 * 【会员注销】注销发验证码之前判断该账号是否检测过账号，同意过注销协议，填写过注销原因
 * @param params
 */
MemberService.prototype.destroyValidate = function(params){
	params.type = 'POST';
	return this._serviceAjaxCom('/publics/member/cancel/validate', params);
};

/**
 * 【会员注销】注销账号
 * @param params
 */
MemberService.prototype.destroyStart = function(params){
	params.type = 'POST';
	return this._serviceAjaxCom('/publics/member/cancel/start', params);
};

MemberService.prototype.updDefault = function(params){
	params.type = 'POST';
	return this._serviceAjaxCom('/publics/memberIdentity/updDefault', params);
};

/**
 * 【会员注销】点击同意协议调的接口
 * @param params
 */
MemberService.prototype.consent = function(params){
	params.type = 'POST';
	return this._serviceAjaxCom('/publics/member/cancel/consent', params);
};

/**
 * 天狗会员 Vip 简单信息
 * 2021-06-29
 * #50108   付费会员——频道页
 * /publics/member/vip/simple/info => /web/member/vip/simple/info => /web/member/vip/info
 * */
MemberService.prototype.tgVipSimpleInfo = function(params){
	params.type = 'GET';
	return this._serviceAjaxCom('/web/member/vip/info', params);
};

/**
 * 未登录获取天狗 Vip 信息
 * 2021-06-29
 * #50108   付费会员——频道页
 * /publics/member/vip/simple/setting => /web/member/vip/simple/setting => /web/member/vip/setting
 * */
MemberService.prototype.tgVipSaving = function(params){
	params.type = 'GET';
	return this._serviceAjaxCom('/web/member/vip/setting', params);
};
MemberService.prototype.vipDetail = function (params) {
	params.type = 'GET'
	return this._serviceAjaxCom('/web/member/vip/info', params);
}
/**
 * 是否是付费会员
 */
MemberService.prototype.isVip = function (params) {
	params.type = 'GET'
	return this._serviceAjaxCom('/web/member/vip/is', params);
}

/**
 * 退出登录
 * @param params
 */
 MemberService.prototype.logout = function(params){
	params.type = 'POST';
	return this._serviceAjaxCom('/web/member/logout', params);
};

/**
 * 会员签到
 * @param params storeId(店铺id)
 */
MemberService.prototype.signin = function(params){
	if( params.data.storeId && maple.util.checkStoreIdFormat(params.data.storeId) ){
		this._serviceAjaxCom('/publics/signRecord/signin', params);
	} else {
		params.success([]);
		return false;
	}
};

/**
 * 会员-消费明细
 *
 */
MemberService.prototype.queryConsume = function (params) {
	params.type = 'POST';
	this._serviceAjaxCom("/publics/memberCard/consume/history/query", params)
};

/**
 * 会员-积分明细
 *
 */
MemberService.prototype.queryHistory = function (params) {
	params.type = 'POST';
	this._serviceAjaxCom("/publics/memberCard/integral/history/query", params)
};

/**
 * 联盟商家详情页
 * @param params id (商家联盟id)
 */
MemberService.prototype.detail = function (params) {
	params.type = 'GET';
	if(params.data.id && maple.util.isInteger(params.data.id)) {
		this._serviceAjaxCom("/publics/ipcItem/detail", params)
	}else {
		return false;
	}
};

/**
 * 收货地址 - 新增地址
 */
MemberService.prototype.addMemberAddress = function (params) {
	params.type = 'POST';
	this._serviceAjaxCom("/publics/memberAddress/addMemberAddress", params)
};

/**
 * 收货地址 - 新增地址
 */
MemberService.prototype.getAddressById = function (params) {
	params.type = 'POST';
	this._serviceAjaxCom("/publics/memberAddress/getById", params)
};

/**
 * 编辑地址 - 删除地址
 */
MemberService.prototype.addMemberDelete = function (params) {
	params.type = 'POST';
	this._serviceAjaxCom("/publics/memberAddress/delete", params)
};

/**
 * 编辑地址 - 删除地址
 */
MemberService.prototype.addMemberUpdate = function (params) {
	params.type = 'POST';
	this._serviceAjaxCom("/publics/memberAddress/update", params)
};

/**
 * 上次下单选择的地址
 */
MemberService.prototype.selectAddress = function (params) {
	params.type = 'POST';
	this._serviceAjaxCom("/publics/memberAddress/select", params)
};

export default new MemberService();
